import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
import { DOMAINE } from '../constants'

Vue.use(VueAxios, axios)

//  Options pour les Ajax
//  Selection du serveur en fonction du mode (development ou production)
if (process.env.NODE_ENV === 'development') {
  Vue.axios.defaults.baseURL = `${DOMAINE}/dev/ajax-webpack`
} else {
  Vue.axios.defaults.baseURL = `${DOMAINE}/ajax-webpack`
}
Vue.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// Vue.axios.defaults.withCredentials = true

/**
 * interceptor qui renvoie vers la page login si non connecté côté serveur
 */
Vue.axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // si réception du code 401 qui indique que l'utilisateur n'a pas de session côté serveur
    // et encore connecté côté client
    // alors on le logout côté client
    if (error.response.status === 401 && store.getters.logged) {
      store.commit('logout')
    }
    // renvoie d'une promise non tenue avec le détail de l'erreur
    return Promise.reject(error)
  }
)

export default new VueAxios({})



// WEBPACK FOOTER //
// ./src/ajax/index.js